<section class="section-div">
  <div class="content-details">
    <div class="title-details">
      <div class="d-flex">
        <h4>Newsletters List</h4>
        <div class="ml-auto">
          <button
            mat-raised-button
            color="primary"
            (click)="eventAddBtn('Add')"
          >
            Add Newsletters
          </button>
        </div>
      </div>
    </div>
    <div *ngIf="noData == false">
      <div class="example-container mat-elevation-z8">
        <mat-table #table [dataSource]="dataSource" [class.isMobile]="isMobile">
          <ng-container matColumnDef="index">
            <mat-header-cell *matHeaderCellDef class="max-width">
              No.
            </mat-header-cell>
            <mat-cell
              *matCellDef="let element; let i = index"
              class="max-width"
            >
              <span class="mobile-label">No :</span>
              {{ paginator.pageSize * paginator.pageIndex + i + 1 }}
            </mat-cell>
          </ng-container>
          <ng-container matColumnDef="title">
            <mat-header-cell *matHeaderCellDef>
              Newsletters Title</mat-header-cell
            >
            <mat-cell *matCellDef="let element">
              <span class="mobile-label">Newsletters Title:</span>
              {{ element.title }}
            </mat-cell>
          </ng-container>
          <ng-container matColumnDef="newsletterName">
            <mat-header-cell *matHeaderCellDef>
              Newsletters Document</mat-header-cell
            >
            <mat-cell *matCellDef="let element">
              <span class="mobile-label"> Newsletters Document:</span>
              <a
                href="{{ element.newsletterName }}"
                target="_blank"
                class="d-flex align-items-center justify-content-center"
              >
                <mat-icon
                  aria-hidden="false"
                  aria-label="Example home icon"
                  fontIcon="download"
                  >download</mat-icon
                >
                Newsletter
              </a>
            </mat-cell>
          </ng-container>
          <ng-container
            matColumnDef="incubatorName"
            [ngClass]="{ 'd-none': roleValue == 'Incubator' }"
          >
            <mat-header-cell *matHeaderCellDef> Incubator Name</mat-header-cell>
            <mat-cell *matCellDef="let element">
              <span class="mobile-label">Incubator Name:</span>
              {{ element.incubatorName }}
            </mat-cell>
          </ng-container>
          <ng-container matColumnDef="action">
            <mat-header-cell *matHeaderCellDef class="max-width4"
              >Action</mat-header-cell
            >
            <mat-cell *matCellDef="let element" class="max-width4">
              <span class="mobile-label">Action:</span>
              <mat-icon
                class="edit-i"
                (click)="editNewletters('Update', element.id)"
              >
                edit</mat-icon
              >
              <mat-icon
                class="delete-i"
                (click)="deleteNewletters(element.id)"
                [ngClass]="{ 'd-none': roleValue == 'Incubator' }"
              >
                delete</mat-icon
              >
            </mat-cell>
          </ng-container>
          <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
          <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
        </mat-table>
      </div>
      <mat-paginator
        #paginator
        class="mat-elevation-z8"
        [length]="pageTotalCount"
        [pageSize]="pageSize"
        [pageSizeOptions]="[25, 50, 75, 100]"
        showFirstLastButtons
        (page)="getServerData($event)"
        aria-label="Select page of periodic elements"
      >
      </mat-paginator>
    </div>
    <div class="text-center no-data-div" *ngIf="noData == true">
      <img src="assets/images/startup-logo.png" class="img-fluid" alt="" />
      <h6>No Records Found</h6>
    </div>
  </div>
</section>
